/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Code_Change_EmailInputs */

const en_us2_auth_code_change_email = /** @type {(inputs: Auth_Code_Change_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Change email`)
};

const pt_br2_auth_code_change_email = /** @type {(inputs: Auth_Code_Change_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trocar e-mail`)
};

const es_419_auth_code_change_email = /** @type {(inputs: Auth_Code_Change_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambiar email`)
};

const pt_pt2_auth_code_change_email = /** @type {(inputs: Auth_Code_Change_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mudar de e-mail`)
};

const fr_fr2_auth_code_change_email = /** @type {(inputs: Auth_Code_Change_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changer d'e-mail`)
};

const de_de2_auth_code_change_email = /** @type {(inputs: Auth_Code_Change_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail ändern`)
};

const it_it2_auth_code_change_email = /** @type {(inputs: Auth_Code_Change_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambia email`)
};

/**
* | output |
* | --- |
* | "Change email" |
*
* @param {Auth_Code_Change_EmailInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const auth_code_change_email = /** @type {((inputs?: Auth_Code_Change_EmailInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Code_Change_EmailInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_auth_code_change_email(inputs)
	if (locale === "es-419") return es_419_auth_code_change_email(inputs)
	if (locale === "pt-PT") return pt_pt2_auth_code_change_email(inputs)
	if (locale === "fr-FR") return fr_fr2_auth_code_change_email(inputs)
	if (locale === "de-DE") return de_de2_auth_code_change_email(inputs)
	if (locale === "it-IT") return it_it2_auth_code_change_email(inputs)
	return en_us2_auth_code_change_email(inputs)
});
export { auth_code_change_email as "auth.code_change_email" }